import { $fetch } from '@/services/axios';

export function fetch(params) {
  return $fetch(`operator/operator/access`, params);
}

export const OPERATOR_ACCESS_CSV_URL = `operator/operator/access/csv`;
